export default "__VITE_ASSET__CvkZjWsx__"